<div class="responsive-tabs mt-20">
    <ng-container *ngFor="let pane of panes; let i = index">
        
        <button 
            (click)="select(i)" 
            [class.active]="pane.active" 
            class="tab-btn"
        >
            {{ pane?.tabTitle }}
            <span class="accordion-icon"></span>
        </button>

        <div class="tab-body" *ngIf="pane.active">
            <app-mini-env-content-box [imgSrc]="imgSrc" [imgSrcMobile]= "imgSrcMob">
                <h2 class="content-heading">{{ pane?.heading }}</h2>
                <p class="content-txt">
                    {{ pane?.subHeading }}
                </p>

                    <ul class="d-flex content-list">
                        <li class="bullet" *ngFor="let item of pane.pointsList">
                            <div>
                                <img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt="">
                            </div>
                            <div>
                                <span class="bullet-heading">{{ item?.title }}: </span>
                                <span>{{ item?.description }}</span>
                            </div>
                        </li>
                    </ul>

                <button *ngIf="pane?.buttonText" (click)="onButtonAction(pane.btnAction)" class="btn btn-primary get-started">{{ pane?.buttonText }}</button>

                <p *ngFor="let note of pane?.notesList" class="note-txt">
                  {{ note }}
                </p>
            </app-mini-env-content-box>
        </div>
    </ng-container>
</div>
